/**
 * Add a basic level of accessibility to the header dropdowns.
 */

let active = undefined;
const dropdowns = Array.from(document.querySelectorAll('.js-nav-item'));

function onFocus(event) {
	const dropdown = event.currentTarget;
	active = dropdown.querySelector('.js-header-nav-item');
	if (active) {
		active.classList.add('is-open');
	}
}

function closeActive(event) {
	if (active && !active.contains(event.target)) {
		active.classList.remove('is-open');
		active = undefined;
	}
}

function init() {
	if (!dropdowns) return;

	dropdowns.forEach(dropdown => {
		dropdown.addEventListener('focus', onFocus, true);
	});

	document.body.addEventListener('focus', closeActive, true);
}

init();
